require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/browse/paginationbutton.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/browse/paginationbutton.legacy.js
// module id = 177
// module chunks = 32 34